// production settings
module.exports = {
    API_URL: 'https://app.fiifi.co/api',
    LI_API_KEY: '771cwtypivbnff',
    LI_REDIRECT: 'https://app.fiifi.co/linkedin-auth.html',
    URL: 'app.fiifi.co',
    LI_SCOPE: 'r_emailaddress r_liteprofile',
    LI_STATE: 'some-string',
    LI_SEC: '9V0J8vhAdjZ7H3N1',
    API_PWD: '1O2qHvxGKwjKvsAPZNpQ',
    API_SALT: 'Imbl9npwpS8wh9nzAolx',
    cred: {
        "aws_project_region": "us-east-1",
        "aws_cognito_identity_pool_id": "us-east-1:b55b2a64-354b-4516-aeb9-b59d307c2043",
        "aws_cognito_region": "us-east-1",
        "aws_user_pools_id": "us-east-1_m1Udmfm8w",
        "aws_user_pools_web_client_id": "1k89nvav4q61c7ofn8okk48net",
        mandatorySignIn: true,
        "oauth": {
            domain: "fiifi.auth.us-east-2.amazoncognito.com",
            scopes: ['email', 'profile', 'aws.cognito.signin.user.admin', 'openid'],
            redirectSignIn: "https://app.fiifi.co/#/dashboard/overview",
            redirectSignOut: "https://app.fiifi.co/#/login",
            redirectSignUp: "https://app.fiifi.co/#/signup",
            responseType: 'code',
            options: {
                AdvancedSecurityDataCollectionFlag: false
            }
        }
    },
    CRUNCHBASE_IMAGE_URL: "https://res.cloudinary.com/crunchbase-production/image/upload"
}